import React from 'react';
import { Star } from 'lucide-react';

// Reusable visual star rating — 5 stars, full/half/empty rendered from a 0-5 value in 0.5
// increments (e.g. 4.5 = 4 full gold stars + 1 half gold/half white). Used everywhere a star
// rating is shown (Team360Table, PillarBubbleSpider) so the visual encoding stays consistent
// — not just a number, per feedback 2026-07-23.
export default function StarRating({ value, size = 16, showNumber = true, gap = 2, color = '#f59e0b', emptyColor = 'var(--border-strong)' }) {
  if (value == null) {
    return <span style={{ fontSize: size * 0.8, color: 'var(--text-dimmed)' }}>—</span>;
  }
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      {showNumber && (
        <span style={{ fontSize: size, fontWeight: 700, color }}>{value.toFixed(1)}</span>
      )}
      <span style={{ display: 'inline-flex', gap }}>
        {[1, 2, 3, 4, 5].map(i => {
          const fill = value >= i ? '100%' : value >= i - 0.5 ? '50%' : '0%';
          return (
            <span key={i} style={{ position: 'relative', width: size, height: size, display: 'inline-block' }}>
              <Star size={size} color={emptyColor} style={{ position: 'absolute', top: 0, left: 0 }} />
              <span style={{ position: 'absolute', top: 0, left: 0, width: fill, height: '100%', overflow: 'hidden' }}>
                <Star size={size} fill={color} color={color} />
              </span>
            </span>
          );
        })}
      </span>
    </span>
  );
}
